import { Button, Input, PinInputField, Textarea } from '@chakra-ui/react';
import { FieldConfig, useField } from 'formik';


interface Props extends FieldConfig {
    align?: 'left' | 'right' | 'center' | 'inBetween';
    type?: 'text' | 'email' | 'password' | 'number' | 'date' | 'radio' | 'checkbox' | 'radiobutton' | 'pinInput' | 'textarea';
    text?: string;
    isTall?: boolean;
    placeholder?: string;
    fieldValue?: string;
    width?: string;
    height?: string;
    handleInputChange?: any
    onKeyUp?: any
    disabled?: boolean
}

const InputField = ({...props}: Props) => {
    const [field, meta] = useField(props as any);


    if (props.type === 'radio') {
        return (
            <Button {...field} width='350px' borderRadius='100px' mt='6' border='solid 1px'>{props.text}</Button>
        )
    } else if (props.type === 'pinInput') {
        return (
            <PinInputField
            {...field}
            // isInvalid={meta.touched && Boolean(meta.error)}
            border='solid 1px grey'
            borderRadius={props.align==='left' ? '8px 0 0 8px' : props.align === 'right' ? '0 8px 8px 0' : props.align === 'center' ? '8px' : props.align === 'inBetween' ? '0' : '8px'}
            height={props.isTall ? '60px' : '48px'}
            fontSize={props.isTall ? '32px' : '24px'}
            placeholder={props.placeholder}
            textAlign='center'
            width='60px'
            />
        )
    } else if (props.type === 'textarea') {
        return (
            <Textarea 
            {...field}
            isInvalid={meta.touched && Boolean(meta.error)}
            borderRadius={props.align==='left' ? '8px 0 0 8px' : props.align === 'right' ? '0 8px 8px 0' : props.align === 'center' ? '8px' : props.align === 'inBetween' ? '0' : '8px'}
            height={props.height}
            fontSize='15px'
            placeholder={meta.touched && meta.error ? meta.error : props.placeholder}
            fontWeight={400}
            width={props.width ? props.width : '100%'}
            onChange = {props.handleInputChange ?  e => {
                field.onChange(e);
                props.handleInputChange(e)
            } : e => field.onChange(e)}
            value={props.fieldValue}
            onKeyUp={props.onKeyUp}
            />
        )
    } else return (
        <Input 
        {...field}
        isInvalid={meta.touched && Boolean(meta.error)}
        placeholder={meta.touched && meta.error ? meta.error : props.placeholder}
        borderRadius={props.align==='left' ? '8px 0 0 8px' : props.align === 'right' ? '0 8px 8px 0' : props.align === 'center' ? '8px' : props.align === 'inBetween' ? '0' : '8px'}
        height='48px'
        fontSize='15px'
        _invalid={
            {
                fontSize: '14px',
                border: 'solid 1px red',
            }
        }
        fontWeight={400}
        width={props.width ? props.width : '100%'}
        onChange = {props.handleInputChange ?  e => {
            field.onChange(e);
            props.handleInputChange(e)
        } : e => field.onChange(e)}
        disabled={props.disabled}
        />
    )
};

export default InputField; 